//毒鸡汤
//当前月份为基数则取single_list，偶数则取double_list
var single_list=[
    '任何质变都来自于量变的积累',
    '不知则问，不能则学',
    '不怕读得少，只怕记不牢',
    '学习要有三心，一信心，二决心，三恒心',
    '三日不读书，便觉语言无味',
    '学固不在乎读书，然不读书则义理无由明',
    '立身以力学为先，力学以读书为本',
    '非读书，不明理。要知事，须读史',
    '书何所求，将以通事理',
    '笔落惊风雨,诗成泣鬼神',
    '别裁伪体亲风雅,转益多师是汝师',
    '博观而约取,厚积而薄发',
    '不飞则已,一飞冲天;不鸣则已,一鸣惊人',
    '学习知识要善于思考，思考，再思考',
    '活着就要学习，学习不是为了活着',
    '好奇心造就科学家和诗人',
    '欲穷千里目，更上一层楼',
    '读书越多，越感到腹中空虚',
    '读一本好书，就是和许多高尚的人谈话',
    '灵感不过是顽强的劳动而获得的奖赏',
    '没有艰苦的学习，就没有最简单的科学发明',
    '略翻书数则，便不愧三餐',
    '智慧养成的习惯，能成为第二天性',
    '书山有路勤为径，学海无涯苦作舟',
    '落日无边江不尽，此身此日更须忙',
    '和书籍生活在一起，永远不会叹气',
    '业精于勤，荒于嬉',
    '血沃中原肥劲草，寒凝大地发春华',
    '光阴给我们经验，读书给我们知识',
    '光景不待人，须叟发成丝',
    '聪明的人有长的耳朵和短的舌头'
];
var double_list=[
    '生命不能从谎言之中开出灿烂的鲜花',
    '黑发不知勤学早，白发方悔读书迟',
    '忧劳可以兴国，逸豫可以亡身',
    '自学，不怕起点低，就怕不到底',
    '聪明出于勤奋，天才在于积累',
    '知之者不如好之者，好之者不如乐之者',
    '不要企图无所不知，否则你将一无所知',
    '读不在三更五鼓，功只怕一曝十寒',
    '韬略终须建新国，奋发还得读良书',
    '一个人应该为知识不广博而害羞',
    '不必每分钟都学习，但求每分钟都有收获',
    '放弃谁都可以，千万不要放弃学习',
    '成功人生三大步骤悟道；立愿；修身',
    '人只要不失去方向，就不会失去自己',
    '快乐不是因为拥有的多而是计较的少',
    '鸟欲高飞先振翅，人求上进先读书',
    '立志宜思真品格，读书须尽苦功夫',
    '勿以恶小而为之，勿以善小而不为',
    '争取时间、争取学习、争取成功',
    '书到用时方恨少，事非经过不知难',
    '书籍是朋友，虽然没有热情，但是非常忠实',
    '书籍乃世人积累智慧之长明灯',
    '读书有三到，谓心到，眼到，口到',
    '书犹药也，善读之可以医愚',
    '聪明在于勤奋，天才在于积累',
    '与肝胆人共事，无字句处读书',
    '读书给人以乐趣，给人以光彩，给人以才干',
    '没有绝望的处境，只有在绝境中不学习的人',
    '勤能补拙是良训，一分辛劳一分才',
    '学习有两忌，自高和自狭',
    '读书也像开矿一样，"沙里淘金"',
];
var chickenSoup = function () {
  var timestamp = Date.parse(new Date());
  var date = new Date(timestamp);
  //获取月份
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  //获取当日日期
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

  //偶数
  if(M%2==0){
    return double_list[D];
  }else{
    return single_list[D];
  }
}
export {
    chickenSoup
};
